//
//  WrongPlane.tsx
//  TrajeXY Signet Server
//
//  Copyright © 2026 TrajeXY. All rights reserved.
//
//  Created: September 23, 2026
//  Author: Bob Keathley
//
//  Full-screen takeover for a token minted for the other plane (spec 27 sec 8).
//  It signs the session out rather than rendering the page, so no inline error.
//
import { auth } from '../auth'
import BrandMark from './BrandMark'

/** A token minted for the other plane landed here (27 §8). Sign it out rather than render anything. */
export default function WrongPlane({ thisPlane }: { thisPlane: 'platform' | 'tenant' }) {
  const otherPlane = thisPlane === 'platform' ? 'tenant' : 'platform'
  return (
    <div className="login">
      <div className="card">
        <BrandMark variant="mark" size={88} />
        <p className="brand">
          <b>Signet</b> Console
        </p>
        <p className="err" role="alert">
          this is the {thisPlane} console; sign in there
        </p>
        <p className="hint">Your account is on the {otherPlane} plane.</p>
        <button className="btn" style={{ width: '100%' }} onClick={() => auth.logout()}>
          Sign out
        </button>
      </div>
    </div>
  )
}
